/* KAIROS mobile gallery v2.0. Uses the theme's Swiper 8 and PhotoSwipe 5. */
(() => {
  'use strict';
  if (window.__kairosMobileGalleryV2) return;
  window.__kairosMobileGalleryV2 = true;

  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  let activeViewer = null;
  const svgNS = 'http://www.w3.org/2000/svg';
  const tr = {
    open: 'G\u00f6rseli b\u00fcy\u00fct', close: 'Kapat',
    gallery: '\u00dcr\u00fcn g\u00f6rselleri',
    zoom: 'Yak\u0131nla\u015ft\u0131r',
    previous: '\u00d6nceki g\u00f6rsel', next: 'Sonraki g\u00f6rsel',
    help: 'Yak\u0131nla\u015ft\u0131rmak i\u00e7in iki parma\u011f\u0131n\u0131z\u0131 a\u00e7\u0131n.',
    exit: '\u00c7\u0131kmak i\u00e7in g\u00f6rseli a\u015fa\u011f\u0131 kayd\u0131r\u0131n.',
    error: 'G\u00f6rsel y\u00fcklenemedi. Kapat\u0131p yeniden deneyin.'
  };
  const closeSVG = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5 5 19"/></svg>';

  function make(tag, className, text) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }
  function icon(path, viewBox) {
    const svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', viewBox);
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const line = document.createElementNS(svgNS, 'path');
    line.setAttribute('d', path); svg.append(line); return svg;
  }
  function saveAttributes(el, names) {
    const values = names.map(name => [name, el.getAttribute(name)]);
    return () => values.forEach(([name, value]) => {
      if (value === null) el.removeAttribute(name); else el.setAttribute(name, value);
    });
  }
  function saveStyles(el, names) {
    const values = names.map(name => [name, el.style.getPropertyValue(name), el.style.getPropertyPriority(name)]);
    return () => values.forEach(([name, value, priority]) => {
      if (value) el.style.setProperty(name, value, priority); else el.style.removeProperty(name);
    });
  }
  function lockPage() {
    const body = document.body, html = document.documentElement;
    const x = window.scrollX, y = window.scrollY;
    const restoreBody = saveStyles(body, ['position', 'top', 'left', 'width', 'overflow']);
    const restoreHtml = saveStyles(html, ['overflow', 'scroll-behavior']);
    body.style.position = 'fixed'; body.style.top = `${-y}px`;
    body.style.left = `${-x}px`; body.style.width = '100%'; body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
    let restored = false;
    return () => {
      if (restored) return;
      restored = true; restoreBody();
      html.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(x, y); restoreHtml();
    };
  }
  function imageData(media, slide) {
    if (slide.dataset.mediaType !== 'image') return null;
    const id = slide.dataset.mediaId;
    const link = Array.from(media.querySelectorAll('a[data-pswp-image]'))
      .find(el => el.dataset.mediaId === id);
    if (!link) return null;
    const width = Number(link.dataset.pswpWidth), height = Number(link.dataset.pswpHeight);
    let src;
    try { src = new URL(link.dataset.pswpSrc || link.getAttribute('href'), location.href); }
    catch (_) { return null; }
    if (!['https:', 'http:'].includes(src.protocol) || !(width > 0 && height > 0)) return null;
    const img = slide.querySelector('img');
    return { id, src: src.href, width, height, element: slide,
      msrc: img?.currentSrc || img?.src || src.href, alt: img?.alt || tr.gallery };
  }

  function openViewer(owner, id, focusTarget) {
    if (!mobile.matches || activeViewer || typeof window.PhotoSwipe !== 'function') return;
    const photos = owner.slides.map(slide => imageData(owner.media, slide)).filter(Boolean);
    const index = photos.findIndex(photo => photo.id === id);
    if (index < 0) return;
    const duration = reducedMotion.matches ? 0 : 300;
    const viewer = new window.PhotoSwipe({
      dataSource: photos, index, mainClass: 'kmg-lightbox', appendToEl: document.body,
      bgOpacity: 1, loop: false, preload: [1, 1],
      initialZoomLevel: 'fit',
      secondaryZoomLevel: level => Math.max(level.fit, Math.min(1, level.fit * 2.5)),
      maxZoomLevel: level => Math.max(1, level.fit * 4),
      paddingFn: viewport => ({ top: 64, bottom: viewport.y < 500 ? 32 : 100, left: 0, right: 0 }),
      showHideAnimationType: reducedMotion.matches ? 'none' : 'zoom',
      showAnimationDuration: duration, hideAnimationDuration: duration,
      zoomAnimationDuration: reducedMotion.matches ? 0 : 320,
      easing: 'cubic-bezier(.22,.68,0,1)',
      closeOnVerticalDrag: true, pinchToClose: true, allowPanToNext: true,
      tapAction: 'zoom', doubleTapAction: 'zoom', imageClickAction: 'zoom',
      bgClickAction: 'close', clickToCloseNonZoomable: false,
      arrowPrev: false, arrowNext: false, zoom: false, counter: false,
      closeSVG, closeTitle: tr.close, zoomTitle: tr.zoom,
      arrowPrevTitle: tr.previous, arrowNextTitle: tr.next, errorMsg: tr.error,
      trapFocus: true, returnFocus: false
    });
    let hint = null, hintTimer = 0, isReady = false, requestedClose = false;
    let closing = false, selectedId = id, cleaned = false;
    // Keep the source image at its original viewport position during opening.
    let unlock = () => {};
    const hideHint = () => { clearTimeout(hintTimer); hint?.classList.remove('is-visible'); };
    const showHint = () => {
      if (!hint || !isReady || closing) return;
      clearTimeout(hintTimer); hint.classList.add('is-visible');
      hintTimer = window.setTimeout(hideHint, 3000);
    };
    const handle = {
      owner,
      close(immediate = false) {
        requestedClose = true;
        if (immediate) { viewer.options.hideAnimationDuration = 0; unlock(); }
        if (isReady) viewer.close();
      }
    };
    activeViewer = handle;
    function cleanup() {
      if (cleaned) return;
      cleaned = true; hideHint(); unlock();
      if (activeViewer === handle) activeViewer = null;
      if (!owner.disposed && !owner.swiper.destroyed) {
        const slideIndex = Array.from(owner.swiper.slides).findIndex(slide => slide.dataset.mediaId === selectedId);
        if (slideIndex >= 0) owner.swiper.slideTo(slideIndex, 0);
        owner.updateCounter();
        const target = owner.slides.find(slide => slide.dataset.mediaId === selectedId) || focusTarget;
        if (target?.isConnected) target.focus({ preventScroll: true });
      }
    }
    viewer.on('afterInit', () => {
      viewer.element.setAttribute('aria-label', tr.gallery);
      viewer.element.setAttribute('aria-modal', 'true');
      viewer.scrollWrap?.setAttribute('aria-roledescription', 'G\u00f6rsel galerisi');
      viewer.element.querySelector('.pswp__button--close')?.addEventListener('click', event => {
        event.preventDefault(); event.stopImmediatePropagation(); handle.close();
      }, true);
      hint = make('div', 'kmg-zoom-help');
      hint.append(icon('M3 9V3h6M15 21h6v-6', '0 0 24 24'), make('span', '', tr.help), make('small', '', tr.exit));
      viewer.element.append(hint);
      // Override only this viewer's background opacity; the existing theme
      // uses !important on PhotoSwipe's background and otherwise blocks fading.
      const applyOpacity = viewer.applyBgOpacity.bind(viewer);
      viewer.applyBgOpacity = value => {
        applyOpacity(value);
        viewer.element?.style.setProperty('--kmg-bg-opacity', String(viewer.bgOpacity));
      };
      unlock = lockPage();
      // With reduced motion, the opening-end event can precede afterInit.
      if (isReady && !requestedClose) showHint();
    });
    viewer.on('openingAnimationEnd', () => {
      isReady = true;
      if (requestedClose) viewer.close(); else showHint();
    });
    viewer.on('change', () => {
      selectedId = photos[viewer.currIndex]?.id || id;
      showHint();
    });
    viewer.on('beforeZoomTo', hideHint);
    viewer.on('zoomPanUpdate', event => {
      if (event.slide?.currZoomLevel > event.slide?.zoomLevels.initial * 1.05) hideHint();
    });
    viewer.on('close', () => {
      closing = true; hideHint();
      // Synchronize before the close animation, so it returns to the same photo.
      if (!owner.disposed && !owner.swiper.destroyed) {
        const i = Array.from(owner.swiper.slides).findIndex(slide => slide.dataset.mediaId === selectedId);
        if (i >= 0) owner.swiper.slideTo(i, 0);
      }
    });
    viewer.on('destroy', cleanup);
    try { if (viewer.init() === false) cleanup(); }
    catch (error) {
      viewer.element?.remove(); cleanup();
      console.warn('[Kairos mobile gallery] Viewer could not open.', error);
    }
  }

  class MobileGallery {
    constructor(media, slider, swiper) {
      this.media = media; this.slider = slider; this.swiper = swiper;
      this.frame = slider.parentElement; this.disposed = false;
      this.cleanups = []; this.nodes = []; this.activeIndex = -1;
      this.ignoreClickUntil = 0; this.pointer = null;
      const seen = new Set();
      this.slides = Array.from(swiper.slides).filter(slide => {
        const id = slide.dataset.mediaId;
        if (!id || seen.has(id) || slide.classList.contains('swiper-slide-duplicate')) return false;
        seen.add(id); return true;
      });
      this.frame.classList.add('kmg-frame');
      if (this.slides.length > 1) this.createIndicator();
      if (typeof window.PhotoSwipe === 'function') this.enableZoom();
      this.onSwiper('slideChange', () => this.updateCounter());
      this.onSwiper('setTranslate', () => this.updateBar());
      this.onSwiper('setTransition', (_, ms) => {
        if (this.piece) this.piece.style.transitionDuration = `${reducedMotion.matches ? 0 : ms || 0}ms`;
      });
      this.onSwiper('destroy', () => this.destroy());
      this.updateCounter(); this.updateBar();
    }
    on(node, event, handler, options) {
      node.addEventListener(event, handler, options);
      this.cleanups.push(() => node.removeEventListener(event, handler, options));
    }
    onSwiper(event, handler) {
      this.swiper.on(event, handler);
      this.cleanups.push(() => { if (this.swiper.off) this.swiper.off(event, handler); });
    }
    createIndicator() {
      this.counter = make('div', 'kmg-counter');
      this.counter.setAttribute('role', 'status');
      this.counter.setAttribute('aria-live', 'polite');
      this.counter.setAttribute('aria-atomic', 'true');
      const windowEl = make('span', 'kmg-number-window');
      windowEl.setAttribute('aria-hidden', 'true');
      this.reel = make('span', 'kmg-number-reel');
      this.slides.forEach((_, i) => this.reel.append(make('span', '', String(i + 1))));
      windowEl.append(this.reel);
      const divider = icon('M5 1 1 19', '0 0 6 20'); divider.classList.add('kmg-counter-divider');
      const total = make('span', '', String(this.slides.length)); total.setAttribute('aria-hidden', 'true');
      this.counter.append(windowEl, divider, total);
      const track = make('div', 'kmg-track'); track.setAttribute('aria-hidden', 'true');
      this.piece = make('span', 'kmg-track-piece');
      this.piece.style.width = `${100 / this.slides.length}%`; track.append(this.piece);
      this.frame.append(this.counter, track); this.nodes.push(this.counter, track);
    }
    updateCounter() {
      if (this.disposed) return;
      const active = this.swiper.slides[this.swiper.activeIndex];
      const index = this.slides.findIndex(slide => slide.dataset.mediaId === active?.dataset.mediaId);
      if (index < 0 || index === this.activeIndex) return;
      this.activeIndex = index;
      if (this.reel) this.reel.style.transform = `translate3d(0,${-index * 22}px,0)`;
      if (this.counter) this.counter.setAttribute('aria-label', `G\u00f6rsel ${index + 1} / ${this.slides.length}`);
      this.slides.forEach((slide, i) => { if (slide.hasAttribute('data-kmg-zoom')) slide.tabIndex = i === index ? 0 : -1; });
    }
    updateBar() {
      if (!this.piece || this.disposed) return;
      const progress = Math.max(0, Math.min(1, Number(this.swiper.progress) || 0));
      this.piece.style.transform = `translate3d(${progress * (this.slides.length - 1) * 100}%,0,0)`;
    }
    enableZoom() {
      this.slides.forEach(slide => {
        if (!imageData(this.media, slide)) return;
        this.cleanups.push(saveAttributes(slide, ['role', 'tabindex', 'aria-label', 'aria-haspopup', 'aria-roledescription', 'data-kmg-zoom']));
        slide.setAttribute('data-kmg-zoom', ''); slide.setAttribute('role', 'button');
        slide.setAttribute('aria-label', tr.open); slide.setAttribute('aria-haspopup', 'dialog');
        slide.removeAttribute('aria-roledescription'); slide.tabIndex = -1;
      });
      this.media.querySelectorAll('a[data-pswp-image]').forEach(link => {
        const opener = link.closest('.product__gallery-opener');
        if (!opener || !this.slides.some(slide => slide.dataset.mediaId === link.dataset.mediaId && slide.hasAttribute('data-kmg-zoom'))) return;
        opener.classList.add('kmg-image-opener'); this.cleanups.push(() => opener.classList.remove('kmg-image-opener'));
      });
      this.on(this.frame, 'pointerdown', event => {
        if (event.isPrimary === false) { this.ignoreClickUntil = Date.now() + 650; this.pointer = null; return; }
        this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, { passive: true });
      const moved = event => {
        if (!this.pointer || this.pointer.id !== event.pointerId) return;
        if (Math.hypot(event.clientX - this.pointer.x, event.clientY - this.pointer.y) > 8) this.ignoreClickUntil = Date.now() + 650;
      };
      this.on(this.frame, 'pointermove', moved, { passive: true });
      this.on(this.frame, 'pointerup', event => { moved(event); this.pointer = null; }, { passive: true });
      this.on(this.frame, 'pointercancel', () => { this.pointer = null; this.ignoreClickUntil = Date.now() + 650; }, { passive: true });
      this.onSwiper('sliderFirstMove', () => { this.ignoreClickUntil = Date.now() + 650; });
      this.on(this.frame, 'click', event => {
        if (!mobile.matches || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const slide = event.target.closest('.swiper-slide[data-kmg-zoom]');
        const link = event.target.closest('a[data-pswp-image]');
        if ((!slide || slide.parentElement !== this.slider.querySelector('.swiper-wrapper')) && !link) return;
        // Capture prevents the theme's old image opener from also opening.
        event.preventDefault(); event.stopImmediatePropagation();
        if (Date.now() < this.ignoreClickUntil || this.swiper.allowClick === false || this.swiper.animating) return;
        const id = slide?.dataset.mediaId || link?.dataset.mediaId;
        openViewer(this, id, slide || link);
      }, true);
      this.on(this.frame, 'keydown', event => {
        const slide = event.target.closest('.swiper-slide[data-kmg-zoom]');
        if (!slide || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault(); event.stopPropagation(); openViewer(this, slide.dataset.mediaId, slide);
      });
    }
    destroy() {
      if (this.disposed) return;
      this.disposed = true;
      if (activeViewer?.owner === this) activeViewer.close(true);
      this.cleanups.forEach(fn => fn()); this.nodes.forEach(node => node.remove());
      this.frame.classList.remove('kmg-frame'); controllers.delete(this.media);
    }
  }

  function scan(scope = document) {
    for (const [media, controller] of controllers) if (!media.isConnected || !mobile.matches) controller.destroy();
    if (!mobile.matches || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-main-product] product-media').forEach(media => {
      if (controllers.has(media)) return;
      const slider = media.querySelector('.product__media-slider > .swiper[data-slider]');
      const swiper = media.settings?.sliderInstance || slider?.swiper;
      if (!slider || !swiper || swiper.destroyed || !swiper.initialized || !swiper.slides?.length) return;
      controllers.set(media, new MobileGallery(media, slider, swiper));
    });
  }
  const start = () => scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.customElements?.whenDefined('product-media').then(start);
  window.addEventListener('load', start, { once: true });
  mobile.addEventListener('change', start);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [media, controller] of controllers) if (event.target.contains(media)) controller.destroy();
  });
  window.addEventListener('pagehide', () => activeViewer?.close(true));
  window.addEventListener('pageshow', event => { if (event.persisted) activeViewer?.close(true); scan(); });
})();
